import { render } from "./ProjectHeader.vue?vue&type=template&id=6e46d59b&scoped=true"
import script from "./ProjectHeader.vue?vue&type=script&lang=js"
export * from "./ProjectHeader.vue?vue&type=script&lang=js"

import "./ProjectHeader.vue?vue&type=style&index=0&id=6e46d59b&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e46d59b"]])

export default __exports__